/* eslint-disable camelcase */
import { getUpdatedCanonicalUrl, PAGE_KEY } from './url';

const getPrevPageUrl = (url, currentPage) => {
    if (currentPage === 2) {
        return url;
    }

    return `${url}?${PAGE_KEY}=${currentPage - 1}`;
};

const getNextPageUrl = (url, currentPage) => `${url}?${PAGE_KEY}=${currentPage + 1}`;

const updateNextPrevLinkTags = (url, paging) => {
    const { pageCount, currentPage } = paging;

    const canonicalTag = document.querySelector('link[rel="canonical"]');
    const prevLink = document.querySelector('link[rel="prev"]');
    const nextLink = document.querySelector('link[rel="next"]');

    const prevPageUrl = getPrevPageUrl(url, currentPage);
    const nextPageUrl = getNextPageUrl(url, currentPage);

    if (currentPage === 1) {
        prevLink?.remove();
    }

    if (currentPage === pageCount) {
        nextLink?.remove();
    }

    if (currentPage > 1 && !prevLink) {
        const newPrevLink = document.createElement('link');
        newPrevLink.setAttribute('rel', 'prev');
        newPrevLink.setAttribute('href', prevPageUrl);

        canonicalTag.after(newPrevLink);
    }

    if (currentPage < pageCount && !nextLink) {
        const newNextLink = document.createElement('link');
        newNextLink.setAttribute('rel', 'next');
        newNextLink.setAttribute('href', nextPageUrl);

        (prevLink ?? canonicalTag).after(newNextLink);
    }

    document.querySelector('link[rel="prev"]')?.setAttribute('href', prevPageUrl);
    document.querySelector('link[rel="next"]')?.setAttribute('href', nextPageUrl);
};

const updateCanonicalTag = (canonicalUrl, metaTitle, paging, requestParameters, isNewListingsCanonicalTagFeatureActive) => {
    document.title = metaTitle;

    const { currentPage } = paging;
    const updatedCanonicalUrl = isNewListingsCanonicalTagFeatureActive
        ? getUpdatedCanonicalUrl(canonicalUrl, requestParameters, currentPage) : canonicalUrl;

    document.querySelector('link[rel="canonical"]').setAttribute('href', updatedCanonicalUrl);
};

const updateDescriptionTag = (description) => {
    document.querySelector('meta[name="description"]').setAttribute('content', description);
};

export const applySeoData = ({
    seoData, paging, requestParameters, isNewListingsCanonicalTagFeatureActive, isNextPrevAttributesFeatureActive
}) => {
    const { canonical_url, meta_title, meta_description } = seoData;

    updateCanonicalTag(canonical_url, meta_title, paging, requestParameters, isNewListingsCanonicalTagFeatureActive);
    updateDescriptionTag(meta_description);

    if (isNextPrevAttributesFeatureActive) {
        updateNextPrevLinkTags(canonical_url, paging);
    }
};
